'use strict';

"use strict";
const cullingMixin = {
  cullArea: null,
  cullable: false,
  cullableChildren: true
};

exports.cullingMixin = cullingMixin;
//# sourceMappingURL=cullingMixin.js.map
